import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import store from "@/store/index.js"
import app from '@/app.js'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      auth: true
    }
  },
  {
    path: '/struct',
    name: 'struct',
    component: () => import('@/views/Structura.vue'),
    meta: {
      auth: true,
      rule: "struct"
    }
  },
  {
    path: '/trans',
    name: 'trans',
    component: () => import('@/views/Transactions.vue'),
    meta: {
      auth: true,
      rule: "trans"
    }
  },
  {
    path: '/card-0/:id',
    name: 'card0',
    component: () => import('@/views/Card-0.vue'),
    meta: {
      auth: true,
      rule: "cardDets"
    }
  },
  {
    path: '/card-1/:id',
    name: 'card1',
    component: () => import('@/views/Card-1.vue'),
    meta: {
      auth: true,
      rule: "cardDets"
    }
  },
  {
    path: '/card-2/:id',
    name: 'card2',
    component: () => import('@/views/Card-2.vue'),
    meta: {
      auth: true,
      rule: "cardDets"
    }
  },
  {
    path: '/card-3/:id',
    name: 'card3',
    component: () => import('@/views/Card-3.vue'),
    meta: {
      auth: true,
      rule: "cardDets"
    }
  },
  {
    path: '/card-4/:id',
    name: 'card4',
    component: () => import('@/views/Card-4.vue'),
    meta: {
      auth: true,
      rule: "cardDets"
    }
  },
  {
    path: '/cards',
    name: 'cards',
    component: () => import('@/views/Cards.vue'),
    meta: {
      auth: true,
      rule: "cards"
    }
  },
  {
    path: '/merch',
    name: 'merch',
    component: () => import('@/views/Merchants.vue'),
    meta: {
      auth: true,
      rule: "profiles"
    }
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('@/views/Admin.vue'),
    meta: {
      auth: true,
      rule: "utils"
    }
  },
  {
    path: '/reports',
    name: 'reports',
    component: () => import('@/views/Reports.vue'),
    meta: {
      auth: true,
      rule: "report"
    }
  },
  {
    path: '/summary',
    name: 'summary',
    component: () => import('@/views/Summary.vue'),
    meta: {
      auth: true,
      rule: "info"
    }
  },
  {
    path: '/logs',
    name: 'logs',
    component: () => import('@/views/Logs.vue'),
    meta: {
      auth: true,
      rule: "log"
    }
  },
  {
    path: '/activity',
    name: 'actlog',
    component: () => import('@/views/ActivityLog.vue'),
    meta: {
      auth: true,
      rule: "actlog"
    }
  },
  {
    path: '/print',
    name: 'printData',
    component: () => import('@/views/Print.vue'),
    meta: {
      auth: true,
      rule: "print"
    }
  },
  {
    path: '/posreports',
    name: 'posReports',
    component: () => import('@/views/PosReports.vue'),
    meta: {
      auth: true,
      rule: "posreport"
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    meta: {
      auth: false
    }
  },
  {
    path: '/tickets',
    name: 'tickets',
    component: () => import('@/views/Tickets.vue'),
    meta: {
      auth: true,
      ruleOr: "tickets.u,tickets.a"
    }
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('@/views/test.vue'),
    meta: {
      auth: false
    }
  },
  {
    path: "/index.html",
    redirect: "/"
  }
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(function (to, from, next) {
  //console.log(to, from, to.meta.auth, store.state.user.userData)
  if (to.meta.auth) {
    //console.log(store.state.user.userData)
    if (store.state.user.userData == null && from.name!="/login") {
      app.ping().then(response => {
        //console.log(response.data.session === "none" || !response.data.rules, response)
        if (response.data.session === "none" || !response.data.rules) {
          next('/login');
        } else {
           //store.state.user.userData = { user: response.data.user, domain: response.data.domain, userinfo: response.data.userinfo};
          // store.state.rules = response.data.rules;
          //console.log("test", app.testRule(to.meta.rule))
          if (app.testRule(to.meta.rule)) next();
        }
      }).catch((e) => {
        console.log(e);
        next('/login');
      });
    } else {
      if(to.meta.ruleOr){
        if (app.testRuleOr(to.meta.ruleOr)) next();
      }else{
        if (app.testRule(to.meta.rule)) next();
      }
    }
  } else {
    next();
  }
})

export default router
